module.exports = __webpack_public_path__ + "media/images/ceremony/plans/3/main-2ffade33c48b32c40015a44be0d6d226.jpg";